export default {"src":"/_next/static/media/facebook.fd6fc3b8.svg","height":56,"width":35,"blurWidth":0,"blurHeight":0};